module.exports = {
    login_now: '立即登入 →',
    err_tryagain: '驗證碼服務器繁忙，請稍後重試(S)',
    input_phone: '請輸入手機號碼',
    phone_error: '手機號輸入錯誤',
    input_imgcode:'請輸入圖形驗證碼',
    imgcode_error: '圖形驗證碼輸入錯誤',
    input_msg: '請輸入手機簡訊驗證碼',
    msg_error: '短信驗證碼輸入錯誤',
    checking: '校驗中...',
    msg_sent:'短信驗證碼已發送',
    imgcode_tips:"圖形驗證碼",
    get_phone_verify : '獲取手機驗證碼',
    get_imgcode:'獲取驗證碼',
    get_imgcode_after: '秒後重新獲取',
    phone_verify:'手機短信驗證碼',
    login_by_phone: '手機驗證登錄',
    please_select:'請選擇',
    cn: '中國(內地)',
    hk: '中國(香港)',
    logout: '登出'
}


// WEBPACK FOOTER //
// ./js/src/i18n/login/hk.js